var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenBidIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 32,
      height: 32
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n     .line-pulse1 {animation:line-pulse1-pulse 0s infinite; stroke-dasharray: 210;}\n     @keyframes line-pulse1-pulse {\n         0%{stroke-dashoffset: 220;}\n         50%{stroke-dashoffset: 0;}\n         100%{stroke-dashoffset: -210;}\n     }\n     @media (prefers-reduced-motion: reduce) {\n         .line-pulse1 {\n             animation: none;\n         }\n     }\n    ")), /*#__PURE__*/React.createElement("path", {
    className: "line-pulse1 stroke1",
    d: "M7 50H23.7762C24.2081 50 24.5912 49.7227 24.7262 49.3125L36.0687 14.8313C36.3683 13.9203 37.6543 13.9127 37.9648 14.82L62.0352 85.18C62.3457 86.0874 63.6317 86.0797 63.9313 85.1687L75.2738 50.6875C75.4088 50.2773 75.7919 50 76.2238 50H92.5",
    stroke: "rgba(0,194,19,1)",
    strokeWidth: "15.0px",
    style: {
      animationDuration: "1.4s"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBidIconGreen);
export default __webpack_public_path__ + "static/media/open_bid_icon-green.0d1814b32bfccdda9ad66f98d7834e2f.svg";
export { ForwardRef as ReactComponent };